<template>
    <v-menu
      left
      min-width="300px"
      rounded
      offset-y
      :close-on-content-click="true">
      <template
        v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          depressed>
          <template
            v-if="!$auth.user.avatarPublicKey">
            <avatar
              tipo="nombre"
              :size="45"
              color="grey"
              :nombre="$auth.user.nombre"
              dark>
            </avatar>
          </template>
          <template v-else>
            <avatar
              tipo="imagen"
              :size="45"
              :imgUrl="`${$urlFileServer}/${$auth.user.avatarPublicKey}`">
            </avatar>
          </template>
        </v-btn>
      </template>
      <v-card>
        <perfil-usuario
        class="pt-6"
        :usuarioId="$auth.user.id"
        soloInfo>
        </perfil-usuario>
        <v-row class="pb-6" justify="center">
          <v-btn
            text
            outlined
            rounded
            :to="{ name: 'miPerfil' }">
            Administrar mi Perfil
          </v-btn>
        </v-row>
        <v-row class="pb-6" justify="center">
          <v-btn
            text
            outlined
            rounded
            :to="{ name: 'logout' }">
            <v-icon
              left>
              mdi-logout
            </v-icon>
            Salir
          </v-btn>
        </v-row>
      </v-card>
    </v-menu>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import PerfilUsuario from '@/components/administracion/configuracion/catalogos/usuarios/PerfilUsuario.vue';

export default {
  name: 'MenuUsuario',
  components: {
    Avatar,
    PerfilUsuario,
  },
  data() {
    return {
      mostrarCambiarPassword: false,
      rutaImagenPerfil: null,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarCambiarPassword = false;
    },
  },
};
</script>

<style lang="scss">

</style>
